import dayjs from "dayjs";

import { BacktestAction } from "../services/backtest-actions";
import { SymbolPrice } from "../services/symbol-prices";

type Props = {
  priceData?: SymbolPrice[];
  backtestActionsData?: BacktestAction[];
  firstDate: dayjs.Dayjs;
};

/**
 * 我們會把 data 的 action 轉換成數字，BUY: 1, SELL: -1
 * backtestActionsData: [{date: "2000-01-01", action: "BUY"}, {date: "2000-01-02", action: "SELL"}]
 * backtestActionsDataMap: { "2000-01-01": 1, "2000-01-02": -1 }
 */
export const getBacktestActionData = ({
  priceData = [],
  backtestActionsData = [],
  firstDate,
}: Props): uPlot.AlignedData => {
  const backtestActionsDataMap: { [key: string]: number } = {};

  const slicedBacktestActionsData = backtestActionsData.filter(
    ({ date }) => firstDate.isSame(date) || firstDate.isBefore(date)
  );

  const slicedPriceData = priceData.filter(
    ({ date }) => firstDate.isSame(date) || firstDate.isBefore(date)
  );

  let [i, j] = [0, 0];
  for (const { date, action } of slicedBacktestActionsData) {
    if (!date || !action) continue;

    if (action === "BUY") i += 1;
    else if (action === "SELL") j += 1;
    backtestActionsDataMap[date] = action === "BUY" ? i : -j;
  }

  const [dates, values, signals]: [number[], number[], number[]] = [[], [], []];

  for (const { date, closePrice } of slicedPriceData) {
    dates.push(dayjs(date).unix());
    values.push(+closePrice?.toFixed(2));
    signals.push(backtestActionsDataMap[date] ?? 0);
  }

  return [dates, values, signals];
};
